var staticEscapeMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;'
}

module.exports = staticEscapeMap



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticEscapeMap.js
// module id = S4SZ
// module chunks = 137